import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { categories } from './categories.schema';
import { files } from './files.schema';

export const checklists = sqliteTable('checklists', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),
  title: text('title').notNull(),
  description: text('description'),
  cloned_id: integer('cloned_id'),
  cloned_uuid: text('cloned_uuid'),
  user_id: integer('user_id'),
  image_id: integer('image_id'),
  image_uuid: text('image_uuid').references(() => files.id),
  old_image_id: integer('old_image_id'),
  old_image_uuid: text('old_image_uuid'),
  category_id: integer('category_id'),
  category_uuid: text('category_uuid').references(() => categories.id),
  publishable: integer('publishable'),
  published_at: text('published_at'),
  banned_at: text('banned_at'),
  is_enabled: integer('is_enabled'),
  organization_id: text('organization_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});

export const checklist_items = sqliteTable('checklist_items', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),
  checklist_id: integer('checklist_id'),
  checklist_uuid: text('checklist_uuid').references(() => checklists.id),
  name: text('name').notNull(),
  position: integer('position').notNull(),
  is_enabled: integer('is_enabled'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});

export const checklist_item_check = sqliteTable('checklist_item_check', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),
  item_id: integer('item_id'),
  item_uuid: text('item_uuid').references(() => checklist_items.id),
  follower_id: integer('follower_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});

export const checklistables = sqliteTable('checklistables', {
  id: text('id').notNull().primaryKey(),
  checklist_id: integer('checklist_id'),
  checklist_uuid: text('checklist_uuid').references(() => checklists.id),
  checklistable_id: integer('checklistable_id'),
  checklistable_uuid: text('checklistable_uuid'),
  checklistable_type: text('checklistable_type'),
  user_id: integer('user_id'),
  organization_id: text('organization_id'),
});
